import React, { Fragment, useEffect, useState } from 'react'
import { Card, MP } from '@newageerp/crm-ui'
import { z } from "zod";
import { axiosInstance } from '@newageerp/v3.bundles.utils-bundle';

type Props = {
    id: number
}

export default function ReportItem(props: Props) {

    const [element, setElement] = useState({
        initial: 0,
        upsell: 0,
        recurring: 0,
        refund: 0
    });

    const getData =async () => {
        const res = await axiosInstance.get(
            `/app/plugins/ReportItem/report-item-payment-data/${props.id}`
        )
        if (res.data) {
            setElement(res.data);
        }
    }
    useEffect(() => {
        getData().catch(console.error)
    }, []);

    // const Element = z.object({
    //     initial_total: z.number(),
    //     upsell_total: z.number(),
    //     recurring_total: z.number(),
    //     refund_total: z.number(),
    // });


    // const [getElement, { element }] = MP.useMpElementRequest<z.infer<typeof Element>>('crm.report_item');
    // useEffect(() => {
    //     getElement({
    //         fields: Element.keyof().options,
    //         id: props.id
    //     })
    // }, []);


    return (
        <Fragment>
                <Card.widget.NumberCardWidget
                    content={{
                        title: "Initial",
                        content: <Card.widget.NumberWithFraction value={element?.initial} currency='usd' />
                    }}
                    isCompact
                />
                <Card.widget.NumberCardWidget
                    content={{
                        title: "Upsell",
                        content: <Card.widget.NumberWithFraction value={element?.upsell} currency='usd' />
                    }}
                    isCompact
                />
                <Card.widget.NumberCardWidget
                    content={{
                        title: "Recurring",
                        content: <Card.widget.NumberWithFraction value={element?.recurring} currency='usd' />
                    }}
                    isCompact
                />
                <Card.widget.NumberCardWidget
                    content={{
                        title: "Refund",
                        content: <Card.widget.NumberWithFraction value={element?.refund} currency='usd' />
                    }}
                    isCompact
                />
        </Fragment>
    )
}
